import React from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'gatsby'
import Content, { HTMLContent } from '../components/Content'
import styled from '@emotion/styled';
import { darkThemeColors, fonts } from '../util/styles';

export const AboutPageTemplate = ({ image, title, content, contentComponent }) => {
  const PageContent = contentComponent || Content

  return (
    <section className="section section--gradient">
      <div className="container">
        <div className="columns">
          <div className="column is-10 is-offset-1">
            <div className="section">
              <Heading >
                {title}
              </Heading>
              <SemiTransparentBackground>
                <PageContent content={content} />
              </SemiTransparentBackground>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}


const Heading = styled(`div`)`
  color: ${darkThemeColors.brandDark};
  padding: 3vmin;
  font: ${fonts.monospace};
  font-size: calc(28px + 0.5vh + 1.5vw);
  line-height: calc(1.1em + 0.5vw);
  background: -webkit-linear-gradient(${darkThemeColors.brandDark}, ${darkThemeColors.brandDark});
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;

const SemiTransparentBackground = styled(`div`)`
  color: ${"black"};
  padding: 3vmin;
`;

AboutPageTemplate.propTypes = {
  image: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  title: PropTypes.string.isRequired,
  content: PropTypes.string,
  contentComponent: PropTypes.func,
}

const AboutPage = ({ data }) => {
  const { markdownRemark: post } = data

  return (
      <AboutPageTemplate
        image={post.frontmatter.image}
        contentComponent={HTMLContent}
        title={post.frontmatter.title}
        content={post.html}
      />
  )
}

AboutPage.propTypes = {
  data: PropTypes.shape({
    markdownRemark: PropTypes.shape({
      frontmatter: PropTypes.object,
    }),
  }),
}

export default AboutPage

export const aboutPageQuery = graphql`
  query AboutPage($id: String!) {
    markdownRemark(id: { eq: $id }) {
      html
      frontmatter {
        title
      }
    }
  }
`
